import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Button } from "../genericComponents";
import { Modal } from "antd";
import "antd/dist/antd.css";
import { GApageView } from "..";


import BlueHero from "../../assets/images/sprites/blueHero.jpg";
const HeaderContainer = styled.div`
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: url("${BlueHero}");
  background-size: 100% 250px;
  background-repeat: repeat-x;
  background-color: white;
`;

const ContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  color: white;
  .modal-video-body {
    margin-top: -300px;
  }
  ${(props) => props.theme.rules.narrowWidth}
  @media (max-width: 720px) {
    flex-direction: column;
  }
`;

const TutorialButton = styled(Button)`
  background-color: #eeaa35;
  color: ${(props) => props.theme.color.goodNightColor};
  padding: 15px 14px 14px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: 0.1px;
  text-align: center;
  color: $goodNightColor;
  min-width: 220px;
  max-height: 50px;
  @media (max-width: 720px) {
    width: 100%;
  }
`;

const Title = styled.div`
  padding: 0px 16px 0px 0;
  width: 70%;
  @media (max-width: 720px) {
    width: 100%;
    display:flex;
    flex-direction: column;
    flex: 1;
    padding: 0px 0px 16px 0;
  }
  h3 {
    color: ${(props) => props.theme.color.gabaYellow};
    font-size: 1.5em;
  }
  p {
    font-size: 1.4em;
  }
`;

//codesandbox.io/s/react-iframe-demo-g3vst codePen =
function Iframe(props) {
  return (
    <div
      dangerouslySetInnerHTML={{ __html: props.iframe ? props.iframe : "" }}
    />
  );
}

const Confesions = () => {
  const [isOpen, setOpen] = useState(false);
  useEffect(() => {
    GApageView("Confersions");
  }, []);
  
  return (
    <div>
      <Modal
        footer={null}

        visible={isOpen}
        onCancel={() => setOpen(false)}
        width={1000}
      >
        <Iframe
          iframe={`<iframe class="airtable-embed airtable-dynamic-height" src="https://airtable.com/embed/shrwpeRKrcDCUG4Fx?backgroundColor=blue" frameborder="0" onmousewheel="" width="100%" height="1183" style="background: transparent; border: 1px solid #ccc;"></iframe>`}
          allow='autoplay'
        />
      </Modal>
      <HeaderContainer>
        <ContentContainer>
          <Title>
            <h3>Confessions</h3>
            <p>
              {" "}
                Someone needs to hear your story and only you can tell it{" "}
              <span role='img' aria-label='hugginface'>
                🤗
                </span>{" "}
                Let's build a community of honesty and support together{" "}
              <span role='img' aria-label='handshake'>
                🤝
                </span>
            </p>
          </Title>
          {/* <ModalVideo
              channel="youtube"
              autoplay
              isOpen={isOpen}
              videoId="UyIQH1aEbxM"
              onClose={() => setOpen(false)}
            /> */}
          <TutorialButton onClick={() => setOpen(true)}>
            Add a Confession
          </TutorialButton>
        </ContentContainer>
      </HeaderContainer>
      <Iframe
        iframe={
          '<iframe class="airtable-embed" src="https://airtable.com/embed/shr4IuNQuOyE9Lqq6?backgroundColor=blue&viewControls=on" frameborder="0" onmousewheel="" width="100%" height="1400px" style="background: transparent; border: 1px solid #ccc;"></iframe>'
        }
        allow='autoplay'
      />
      <script src='https://static.airtable.com/js/embed/embed_snippet_v1.js'></script>
    </div>
  );
};

export default Confesions;
